export const BlogTags = {
  AI: 'ai',
  ANNOUNCEMENT: 'announcement',
  ARCHITECTURE: 'architecture',
  CASE_STUDY: 'case-study',
  CLOUD: 'cloud',
  COMMUNITY: 'community',
  DEPLOYMENT: 'deployment',
  DEVOPS: 'devops',
  EDGE: 'edge',
  ENGINEERING: 'engineering',
  ENTERPRISE: 'enterprise',
  LAUNCH_WEEK: 'launch-week',
  MICRO_FRONTENDS: 'micro-frontends',
  MOBILE: 'mobile',
  OPS: 'ops',
  POLYCLOUD: 'polycloud',
  PRODUCT: 'product',
  REACT_NATIVE: 'react-native',
  TUTORIAL: 'tutorial',
  WEB: 'web',
} as const;

export type BlogTag = typeof BlogTags[keyof typeof BlogTags];

export const tagLabels: Record<BlogTag, string> = {
  [BlogTags.AI]: 'AI',
  [BlogTags.ANNOUNCEMENT]: 'Announcement',
  [BlogTags.ARCHITECTURE]: 'Architecture',
  [BlogTags.CASE_STUDY]: 'Case Study',
  [BlogTags.CLOUD]: 'Cloud',
  [BlogTags.COMMUNITY]: 'Community',
  [BlogTags.DEPLOYMENT]: 'Deployment',
  [BlogTags.DEVOPS]: 'DevOps',
  [BlogTags.EDGE]: 'Edge',
  [BlogTags.ENGINEERING]: 'Engineering',
  [BlogTags.ENTERPRISE]: 'Enterprise',
  [BlogTags.LAUNCH_WEEK]: 'Launch Week',
  [BlogTags.MICRO_FRONTENDS]: 'Micro Frontends',
  [BlogTags.MOBILE]: 'Mobile',
  [BlogTags.OPS]: 'Ops',
  [BlogTags.POLYCLOUD]: 'Polycloud',
  [BlogTags.PRODUCT]: 'Product',
  [BlogTags.REACT_NATIVE]: 'React Native',
  [BlogTags.TUTORIAL]: 'Tutorial',
  [BlogTags.WEB]: 'Web',
};
